import React, { useEffect } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import { Stack, Paper, Box, Typography, LinearProgress } from '@mui/material';
import TabBar from './TabBar';
import Pending from './Pending';
import Approved from './Approved';
import Refused from './Refused';
import FilterBar from './components/FilterBar';
import utils from 'components/utils';

const WishlistSpecial = props => {
	const iCan = utils.usePermissions();
	const translate = utils.useI18N();
	const loadingWishlists = useStoreState(state => state.wishlistSpecial.loadingWishlists);
	const tabSelected = useStoreState(state => state.wishlistSpecial.tabSelected);

	return (
		<Stack
			direction="column"
			justifyContent="flex-start"
			alignItems="flex-start"
			spacing={0}
			sx={{ minHeight: '100vh' }}
		>
			<Paper variant="stickyTop">
				<Stack
					direction="row"
					justifyContent="flex-stat"
					alignItems="flex-start"
					spacing={1}
					variant="wrapperColor"
					sx={{ width: '100%' }}
				>
					<Box sx={{ width: { xs: '70%', md: '90%', sm: '80%' } }}>
						<Typography variant="titlePage">{translate('common.menu.wishlistSpecial')}</Typography>
					</Box>
				</Stack>
				<TabBar />
				<FilterBar />
				{loadingWishlists && <LinearProgress />}
			</Paper>
			{tabSelected == 0 && <Pending />}
			{tabSelected == 1 && <Approved />}
			{tabSelected == 2 && <Refused />}
		</Stack>
	);
};

export default WishlistSpecial;
